import React from "react";
import PropTypes from "prop-types";
import SmartSnippet from "../../algolia_search/smart_snippet";

function OverviewQuoteOrExpertList({ searchHit }) {
  let attributeToDisplay;

  if (!searchHit.headline && !searchHit.description && !searchHit.latest_quote && !searchHit.experts_summary)
    return null;

  const { _highlightResult: hr } = searchHit;

  // Determine what to display based on whether we're displaying a search results and,
  // if so, where the match is.
  if (hr) {
    // This is a search result, so look for any match highlights
    if (hr.headline && hr.headline.matchLevel !== "none") {
      attributeToDisplay = "headline";
    } else if (hr.description && hr.description.matchLevel !== "none") {
      attributeToDisplay = "description";
    } else if (hr.latest_quote && hr.latest_quote.matchLevel !== "none") {
      attributeToDisplay = "latest_quote";
    } else if (hr.quotes) {
      const i = hr.quotes.findIndex((q) => q.quote && q.quote.matchLevel !== "none");
      // https://github.com/algolia/instantsearch/issues/5791#issuecomment-1661818749
      if (i > -1) attributeToDisplay = ["quotes", i, "quote"];
    }
  }

  // Fall back to regular, non-search-result logic if we don't have an attribute yet
  if (!attributeToDisplay) {
    if (searchHit.headline) {
      attributeToDisplay = "headline";
    } else if (searchHit.description) {
      attributeToDisplay = "description";
    } else if (searchHit.latest_quote) {
      attributeToDisplay = "latest_quote";
    } else {
      attributeToDisplay = "experts_summary";
    }
  }

  return (
    <div className="smaller mt-2">
      {attributeToDisplay === "latest_quote" && <span className="fw-bold">LATEST: </span>}
      <em className="text-secondary">
        <SmartSnippet attribute={attributeToDisplay} hit={searchHit} />
      </em>
    </div>
  );
}

OverviewQuoteOrExpertList.propTypes = {
  searchHit: PropTypes.instanceOf(Object).isRequired,
};

export default OverviewQuoteOrExpertList;
